import classNames from 'classnames';
import dynamic from 'next/dynamic';
import React from 'react';

import { BANNER_TYPES } from '@sravni/react-advertisement';
import { Layout } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { AboutBlock } from '@components/AboutBlock';
import { EmptyRating } from '@components/EmptyRating';
import { RatingTable } from '@components/RatingTable';
import { RatingTypeButtons } from '@components/RatingTable/components/RatingTypeButtons/RatingTypeButtons';

import { useGenerateTabs } from '../../hooks/useGenerateTabsForSpecialOffers';
import { useIsWlPage } from '../../hooks/useIsWlPage';
import { AB_NAME } from '../../pages/_app';
import { useBanners, useIsLoadedBanners } from '../../store/hooks/advertising';
import { useRatingsList } from '../../store/hooks/ratings';
import pageStyles from '../../styles/page.module.scss';
import { GiveFeedback } from '../GiveFeedback';
import { SpecialOffersBlock } from '../SpecialOffersBlock';

const SeoBlocks = dynamic(() => import('../SeoBlocks').then((mod) => mod.SeoBlocks));
const Banner = dynamic(() => import('@sravni/react-advertisement').then((mod) => mod.Banner), {
  ssr: false,
});

export const RatingsContent = () => {
  const isMobile = useIsMobile();
  const banners = useBanners();
  const isLoadedBanners = useIsLoadedBanners();
  const tabs = useGenerateTabs();
  const isWl = useIsWlPage();
  const rating = useRatingsList();

  return (
    <Layout className="h-mt-36">
      <AboutBlock />
      <div className={classNames(pageStyles.content, isMobile ? 'h-mt-20' : 'h-mt-32')}>
        <div className={pageStyles.contentColumn}>
          {!isWl && isMobile && (!isLoadedBanners || banners?.[BANNER_TYPES.TGBM_7]) && (
            <div className={pageStyles.fullwidthPhone}>
              <Banner
                banner={banners?.[BANNER_TYPES.TGBM_7]}
                type={BANNER_TYPES.TGBM_7}
                className={pageStyles.adsTgbm7Top}
                abName={AB_NAME}
              />
            </div>
          )}
          <RatingTypeButtons />
          <div className={pageStyles.fullwidthPhone}>
            {rating && Boolean(rating?.length) ? <RatingTable rating={rating} /> : <EmptyRating />}
          </div>
          {!isWl && !isMobile && (!isLoadedBanners || banners?.[BANNER_TYPES.TGBM_7]) && (
            <Banner
              banner={banners?.[BANNER_TYPES.TGBM_7]}
              type={BANNER_TYPES.TGBM_7}
              className={pageStyles.adsTgbm7Bottom}
              abName={AB_NAME}
            />
          )}
          <SpecialOffersBlock tabs={tabs} />
          <SeoBlocks />
        </div>

        {!isMobile && (
          <aside>
            <GiveFeedback />
            {!isWl && (!isLoadedBanners || banners?.[BANNER_TYPES.SIDE]) && (
              <div className={pageStyles.sticky}>
                <Banner
                  banner={banners?.[BANNER_TYPES.SIDE]}
                  type={BANNER_TYPES.SIDE}
                  className={pageStyles.adsSide}
                  abName={AB_NAME}
                />
              </div>
            )}
          </aside>
        )}
      </div>
      {!isWl && isMobile && (!isLoadedBanners || banners?.[BANNER_TYPES.SIDE]) && (
        <Banner
          banner={banners?.[BANNER_TYPES.SIDE]}
          type={BANNER_TYPES.SIDE}
          className={pageStyles.adsSide}
          abName={AB_NAME}
        />
      )}
    </Layout>
  );
};
